var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameAutorenewMobile = function SvgIconStorygameAutorenewMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.938h-2l2.667 2.666 2.666-2.666h-2A5.332 5.332 0 0 0 8 3.604c-1.047 0-2.02.307-2.84.827l.973.973A3.914 3.914 0 0 1 8 4.938c2.207 0 4 1.793 4 4Zm-1.16 4.506-.973-.973A4.011 4.011 0 0 1 8 12.938c-2.207 0-4-1.794-4-4h2L3.333 6.27.667 8.938h2A5.332 5.332 0 0 0 8 14.27c1.047 0 2.02-.307 2.84-.827Z",
    fill: "url(#icon-storygame-autorenew-mobile_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-storygame-autorenew-mobile_svg__a",
    x1: 15.333,
    y1: 14.271,
    x2: 0.39,
    y2: 4.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753BBD"
  })))));
};
export default SvgIconStorygameAutorenewMobile;